"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const foundations_1 = require("@airstudio/foundations");
function get(key) {
    return (s) => {
        if (key) {
            return foundations_1._.get(s.config.config, key);
        }
        return s.config.config;
    };
}
exports.get = get;
function state(s) {
    const { errorMessage, isProcessing } = s.config;
    return { errorMessage, isProcessing };
}
exports.state = state;
//# sourceMappingURL=selectors.js.map